import { Link } from 'react-router-dom'

export default function Home() {
  return (
    <div>
      {/* Hero */}
      <section className="py-16 md:py-24 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <img 
            src="/PraxisCRM.png" 
            alt="Praxis CRM" 
            className="h-20 w-20 mx-auto mb-6"
          />
          <h1 className="text-3xl md:text-4xl font-semibold text-text-primary mb-6 leading-tight">
            Your CRM. Not ours. Actually.
          </h1>
          <p className="text-lg text-text-secondary mb-8 max-w-2xl mx-auto">
            Most software says "your data is safe with us". We went further!  
            <strong>Your data never reaches us at all</strong>. Everything lives in your Google Drive. 
            We have no database. We have no way to peek.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/login" className="btn btn-primary">
              Get Started
            </Link>
            <Link to="/how-it-works" className="btn btn-secondary">
              See How It Works
            </Link>
          </div>
        </div>
      </section>

      {/* Key points */}
      <section className="py-16 px-6 bg-[#F5F5F3]">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <article className="card">
              <h2 className="font-semibold text-lg text-text-primary mb-3">
                We can't steal your data
              </h2>
              <p className="text-sm text-text-secondary">
                Not "we promise not to". <strong>We literally cannot.</strong> No servers. No database. 
                No sneaky backend. Your data goes straight from your browser to your Drive.
              </p>
            </article>

            <article className="card">
              <h2 className="font-semibold text-lg text-text-primary mb-3">
                Free. No asterisk.
              </h2>
              <p className="text-sm text-text-secondary">
                No premium tier. No "upgrade to unlock". No subscription. Free for you for as long as it lives. 
              </p>
            </article>

            <article className="card">
              <h2 className="font-semibold text-lg text-text-primary mb-3">
                Built for people who work for themselves
              </h2>
              <p className="text-sm text-text-secondary">
                Contractors, freelancers, consultants. People who don't need enterprise bloat 
                but do need to track their pipeline. Everything you need. Nothing you don't.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* Features overview */}
      <section className="py-16 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl font-semibold text-text-primary mb-8 text-center">
            What's included
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="card">
              <h3 className="font-medium text-text-primary mb-2">Pipeline Board</h3>
              <p className="text-sm text-text-secondary">
                Drag-and-drop Kanban board to track deals. 
                See your entire sales pipeline at a glance.
              </p>
            </div>

            <div className="card">
              <h3 className="font-medium text-text-primary mb-2">Company Ledger</h3>
              <p className="text-sm text-text-secondary">
                Keep records of every company you work with: websites, industries, 
                notes, and all associated contacts.
              </p>
            </div>

            <div className="card">
              <h3 className="font-medium text-text-primary mb-2">Prospect Research</h3>
              <p className="text-sm text-text-secondary">
                Auto-research companies from public sources. Website data, UK company 
                registry, and AI-powered fit assessment tailored to your business.
              </p>
            </div>

            <div className="card">
              <h3 className="font-medium text-text-primary mb-2">AI Integration</h3>
              <p className="text-sm text-text-secondary">
                Bring your own AI provider. Your API key, your costs, your control. 
                We support OpenAI, Anthropic, Gemini, and OpenRouter.
              </p>
            </div>

            <div className="card">
              <h3 className="font-medium text-text-primary mb-2">Contact Directory</h3>
              <p className="text-sm text-text-secondary">
                Store contact details for everyone in your network, linked to 
                their companies and your deals.
              </p>
            </div>

            <div className="card">
              <h3 className="font-medium text-text-primary mb-2">Activity Timeline</h3>
              <p className="text-sm text-text-secondary">
                Log calls, emails, meetings, and notes. Keep a record of every 
                interaction without manual data entry.
              </p>
            </div>

            <div className="card">
              <h3 className="font-medium text-text-primary mb-2">Privacy Vault</h3>
              <p className="text-sm text-text-secondary">
                See exactly what files exist in your Drive. Clear local caches 
                or export all your data in one click.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-6 bg-[#F5F5F3]">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl font-semibold text-text-primary mb-4">
            Stop renting access to your own data
          </h2>
          <p className="text-text-secondary mb-6">
            Your pipeline. Your contacts. Your Drive. No middleman.
          </p>
          <Link to="/login" className="btn btn-primary">
            Connect Google Drive
          </Link>
        </div>
      </section>
    </div>
  )
}
